import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CardSelectionPage from './pages/CardSelectionPage';
import DedicatedAddressPage from './pages/DedicatedAddressPage';

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<CardSelectionPage />} />
                    <Route path="/wallet" element={<DedicatedAddressPage />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;